import React from "react";

import { DEFAULT_CARD_HEIGHT, TAG } from "config/constants";
import TagStreamWrapper from "stream/containers/TagStreamWrapper";
import Stream from "stream/containers/Stream";
import FullStoryCard from "cards/containers/FullStoryCard";
import PromoStreamCap from "stream/components/PromoStreamCap";
import Helmet from "react-helmet-async";
import IssuesModule from "stream/containers/IssuesModule";

import image from "assets/img/data-privacy-deep-dive.png";
import ogImage from "assets/img/data-privacy-deep-dive-social.png";

export default function DataPrivacyTagStream() {
  const StreamShoe = () => (
    <IssuesModule
      boxes={[
        {
          name: "Online Privacy",
          tagSlug: "online-privacy",
          backgroundColor: "#656565",
        },
        {
          name: "Personal data",
          tagSlug: "personal-data",
          backgroundColor: "#656565",
        },
        {
          name: "Facebook",
          tagSlug: "facebook",
          backgroundColor: "#656565",
        },
        {
          name: "Google",
          tagSlug: "google",
          backgroundColor: "#656565",
        },
      ]}
    />
  );

  return (
    <>
      <Helmet>
        <meta property="og:image" content={ogImage} />
      </Helmet>
      <TagStreamWrapper slug={TAG.DATA_PRIVACY.slug}>
        {({ streamParams }) => (
          <>
            <PromoStreamCap
              promo={{
                title:
                  "Personal data is our most valuable asset, but we've given it away to powerful corporations",
                content: (
                  <span>
                    Explore below and{" "}
                    <a
                      className="gtm-promo-stream-cap-content-link"
                      href="https://signup.axios.com/2019/am.html?source=axios&medium=referral&campaign=stream_cap_promo_link"
                    >
                      sign up for Axios AM{" "}
                    </a>
                    for more deep dives into the most important topics affecting
                    our world.
                  </span>
                ),
                contentForAnalytics:
                  "Explore below and sign up for Axios AM for more deep dives into the most important topics affecting our world.",
                image: image,
              }}
            />
            <Stream
              {...streamParams}
              defaultCardHeight={DEFAULT_CARD_HEIGHT.FULL_STORY_CARD}
              contentComponent={FullStoryCard}
              streamShoeComponent={StreamShoe}
            />
          </>
        )}
      </TagStreamWrapper>
    </>
  );
}
